import React from 'react';
import StepperContainer from './stepper';

export const StepComponent = () => {
    return (
        <div className='product-modall-wrapper'>
           <StepperContainer />
        </div>
     )
}